import { ProductI } from './products';

export interface CheckoutDataI {
  // selectedProduct: ProductI;
  selectedProductId: string;
  quantity: number;
  tax_state: string;
  serviceFeePriceId: string;
  productDefaultPriceId: string;
}

/**
 * Flat payment-status payload handed to `CheckoutService.processOrder`.
 *
 * The sole production caller (`SignupCheckoutComponent.processPaymentForm`)
 * passes `{ status: this.paymentIntentStatus, amount: this.paymentIntentAmount }`
 * where `paymentIntentStatus` is the (string-widened) Stripe PaymentIntent
 * status. Both fields are optional so the error-path test
 * (`processOrder('pi_fail', {})`) and partially-populated callers still
 * type-check. `status` is a plain `string` to match the component field and the
 * backend DTO, which accepts the status as free text.
 */
export interface PaymentInfoStatusI {
  status?: string;
  amount?: number;
}

/**
 * Generic booking/order POST result returned by the payment + reschedule
 * endpoints. The backend returns `orderId`/`bookingId` for the booking routes
 * and `id` for the credit/reschedule routes; all are optional so a single shape
 * can describe every response without an `any` cast.
 */
export interface BookingOrderResultI {
  id?: string;
  orderId?: string;
  bookingId?: string;
}

/**
 * Outbound DTO posted to `process-payment`. The backend payment controller
 * accepts an open-ended bag of payment fields; kept as a string-keyed map of
 * primitives so callers stay free of `any` while not over-constraining a shape
 * owned by the server-side DTO.
 */
export type ProcessPaymentDataI = Record<string, string | number | boolean | null | undefined>;
